import React from 'react'

export default function LinkAttachmentIcon() {
  return (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.03807 6.62868C7.8665 5.45711 5.967 5.45711 4.79543 6.62868L1.79543 9.62868C0.623855 10.8003 0.623855 12.6997 1.79543 13.8713C2.967 15.0429 4.8665 15.0429 6.03807 13.8713L6.86424 13.0451M6.29543 9.37132C7.467 10.5429 9.3665 10.5429 10.5381 9.37132L13.5381 6.37132C14.7096 5.19975 14.7096 3.30025 13.5381 2.12868C12.3665 0.957107 10.467 0.957107 9.29543 2.12868L8.47072 2.95339" stroke="#A4A4A4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
